import React, {useEffect, useState} from "react";
import { BankDetails } from "../../interfaces/bank";
import BankingService from '../../api/bank-service'
import { BankCard } from "./BankCard";

export function VerificationStep({
  details,
  onComplete,
}: {
  details: BankDetails
  onComplete: (s: 'success' | 'failed') => void
}) {
  const [apiError, setApiError] = useState('')

  useEffect(() => {
    // ── POST /estates/payout-account ────────────────────────────────────────
    const save = async () => {
      try {
        await BankingService.setEstatePayoutAccount({
          bankName: details.bankName,
          bankCode: details.bankCode,
          accountNumber: details.accountNumber,
          accountName: details.accountName,
        })
        onComplete('success')
      } catch (err: any) {
        setApiError(err?.response?.data?.message ?? 'Verification failed. Please try again.')
        onComplete('failed')
      }
    }

    save()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-gray-900">
        We are Verifying this bank Account.
      </h2>
      <BankCard details={details} />
      {apiError ? (
        <p className="text-sm text-red-500">{apiError}</p>
      ) : (
        <div className="flex items-baseline gap-2.5 text-base text-gray-600 max-w-full">
          <span className="text-amber-500 mt-0.5 flex-shrink-0 text-base">⚠</span>
          <span className="break-words">
            We're checking that this bank account matches the estate's details. This may take a couple of minutes.
          </span>
        </div>
      )}
    </div>
  )
}